/**
 * 设备类型模块
 * date:2022 06 10
 */
import httpRequest from '@/utils/request.js'

/** 设备类型列表接口 */
export const deviceTypeList = (params = {}, type) =>
  httpRequest.httpGet({
    url: '/service/deviceType/list/' + type,
    params: {
      ...params
    }
  })
/** 获取探测设备类型详细信息接口接口 */
export const deviceTypeDetail = (type, id) =>
  httpRequest.httpGet({
    url: '/service/deviceType/detail/' + type + '/' + id
  })
/** 新增设备类型接口 */
export const deviceTypeAdd = (data = {}, type) =>
  httpRequest.httpPost('/service/deviceType/add/' + type, data)
/** 编辑设备类型接口 */
export const deviceTypeEdited = (data = {}, type) =>
  httpRequest.httpPost('/service/deviceType/edited/' + type, data)
/** 删除设备类型接口 */
export const deviceTypeDelete = (data = {}, type) =>
  httpRequest.httpdelete('/service/deviceType/delete/' + type, data)
